//import authHeader from './auth-header';
import { baseStrapiUrl } from "../assets/linkTree";

export default {
    baseURL: baseStrapiUrl +'/api',
    timeout: 1000,

    connData(extraConfig) {
        return {... {
                baseURL: process.env.baseURL || this.baseURL,
                //headers: authHeader(),
            },
            ...extraConfig
        }
    }
};